<template>
    <div style="display: inherit">
        <button class="btn btn-info" data-bs-toggle="modal" data-bs-target="#availabilityModal">View
            Availabilities
        </button>
        <div id="availabilityModal" class="modal" tabindex="-1" ref="availabilityModal">
            <div class="modal-dialog modal-fullscreen">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Availabilities</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div v-if="Object.keys(eventTimeList).length">
                            <div v-for="(timeArr, day) in eventTimeList" :key="day.toString()" class="row mb-2">
                                <p class="p-3 bg-success text-center font-size-lg text-white fw-semibold">{{ day }}</p>
                                <div class="row item-push mb-3"
                                     v-if="timeArr['appointment'] && timeArr['appointment'].length">
                                    <h5><span class="badge rounded-pill bg-info">Appointments</span></h5>
                                    <div class="col-6 col-md-6 col-xl-3" v-for="(time, i) in timeArr['appointment']"
                                         :key="`appointment-${i}`">
                                        <div class="card shadow bg-body-dark my-4">
                                            <div class="card-body">
                                                <h3 class="card-title">
                                                    Meeting
                                                </h3>
                                                <div class="card-text">
                                                    <p>{{ time.start }} - {{ time.end }} ({{ userZone }})</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <h5><span class="badge rounded-pill bg-info">Availabilities</span></h5>
                                <div class="row item-push" v-if="timeArr['available'] && timeArr['available'].length">
                                    <div class="col-6 col-md-4 col-xl-2" v-for="(time, i) in timeArr['available']"
                                         :key="`available-${i}`">
                                        <div class="card shadow bg-body-dark my-4">
                                            <div class="card-body">
                                                <p class="card-text">{{ time.start }} - {{ time.end }} ({{
                                                        userZone
                                                    }})</p>
                                            </div>
                                            <div class="card-footer">
                                                <button type="button" class="btn btn-sm btn-danger"
                                                        @click="deleteAvailability(time)"><i
                                                    class="fas fa-trash-alt"></i> Delete Availability
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            No availability existed
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import calendar from '../../mixins/calendar'
import { Modal } from 'bootstrap'

export default {
    name: 'AvailabilityModal',
    props: {
        userZone: {
            type: String,
        },
    },
    mixins: [calendar],
    computed: {
        modal () {
            const target = this.$refs.availabilityModal
            return new Modal(target, {})
        },
        eventTimeList () {
            return this.generateEventTimeList(this.availableList, this.userZone)
        },
        ...mapGetters({
            availableList: 'events/events',
        }),
    },
}
</script>

<style scoped>

</style>
